import { VideoProps } from './component';

export type VideoControlsProps = VideoProps;
